export default "__VITE_ASSET__72cacb6d__"